const itadConfig = {
    clientId: "2a8d4ff76c308e98",
    clientSecret: "bc445cad3306f372fa72c8bb17a7f24f8a762a36",
    apiKey: "27ca895b9e9791e75974e5357a7737797191ace4",
};

export default itadConfig;